<div *ngIf="pin != null" class="pin-info-container pin-event-container">
  <div class="pin-image">
    <div class="pin-date">
      {{ pin.start_at | formattedDate }}
    </div>
    <img [src]="pin.image || pin.event_theme_image" alt="" />
  </div>

  <div class="pin-tags">
    <a *ngFor="let category of pin.categories" class="pin-tag"
       [routerLink]="category.id | tagRouterLink:'event'"
       [queryParams]="category.id | tagQueryParams">
      {{ category.name }}
    </a>
  </div>

  <div class="pin-title">
    {{ pin.name }}
  </div>

  <ul class="pin-description">
    <li>
      <mat-icon fontIcon="schedule" class="material-icons-outlined"></mat-icon>
      <span>
        {{ pin.start_at | dateRange: pin.end_at }}
      </span>
    </li>

    <li>
      <mat-icon fontIcon="location_on" class="material-icons-outlined"></mat-icon>
      <span>
        {{ pin.address | formattedAddress }}
      </span>
    </li>

    <li *ngIf="pin.is_public">
      <mat-icon fontIcon="public" class="material-icons-outlined"></mat-icon>
      <span>
        {{ 'HOMEPAGE.MAP.info_window.public_event' | translate }}
      </span>
    </li>

    <li *ngIf="!pin.is_public">
      <mat-icon fontIcon="lock" class="material-icons-outlined"></mat-icon>
      <span>
        {{ 'HOMEPAGE.MAP.info_window.private_event' | translate }}
      </span>
    </li>

    <li *ngIf="pin.participants_count > 0">
      <mat-icon fontIcon="people" class="material-icons-outlined"></mat-icon>
      <span>
        {{ pin.participants_count }}
        {{ 'HOMEPAGE.MAP.info_window.participants' | translate }}
      </span>
    </li>
  </ul>

  <div class="pin-button">
    <a [routerLink]="['/events/' + pin.id]" [innerHTML]="'HOMEPAGE.MAP.buttons.view_details' | translate"></a>
  </div>
</div>
